var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.4684 4.71333C17.8322 4.99474 17.1575 5.17956 16.4667 5.26167C17.1948 4.82619 17.7398 4.14085 18 3.33333C17.3167 3.74 16.5675 4.025 15.7867 4.17917C15.2622 3.61798 14.567 3.2458 13.8092 3.12049C13.0513 2.99517 12.2733 3.12374 11.5961 3.48621C10.9189 3.84868 10.3804 4.42474 10.0643 5.12483C9.74825 5.82492 9.67233 6.60982 9.84838 7.3575C8.46263 7.28805 7.10699 6.92794 5.86945 6.30055C4.63191 5.67317 3.54015 4.79254 2.66504 3.71583C2.35529 4.24788 2.19251 4.85269 2.19338 5.46833C2.19338 6.67667 2.80838 7.74417 3.74338 8.36917C3.19005 8.35175 2.6489 8.20232 2.16504 7.93333V7.97667C2.16521 8.78142 2.44369 9.56135 2.95325 10.1842C3.46282 10.8071 4.17211 11.2346 4.96088 11.3942C4.44722 11.5334 3.90863 11.5539 3.38588 11.4542C3.60827 12.1469 4.04172 12.7527 4.62554 13.1868C5.20936 13.6209 5.91432 13.8615 6.64171 13.875C5.91878 14.4428 5.09103 14.8625 4.20578 15.1101C3.32053 15.3578 2.39515 15.4285 1.48254 15.3183C3.07563 16.3429 4.93012 16.8868 6.82421 16.885C13.235 16.885 16.7409 11.5742 16.7409 6.96833C16.7409 6.81833 16.7367 6.66667 16.73 6.51833C17.4124 6.02514 18.0014 5.41418 18.4692 4.71417L18.4684 4.71333Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.4ec61e55646b17a06d855c8833f6f205.svg";
export { ForwardRef as ReactComponent };